var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.mode == "edit"
        ? _c(
            "el-select",
            {
              ref: "select",
              staticClass: "wp-10",
              attrs: {
                filterable: "",
                multiple: _vm.multiple,
                remote: "",
                placeholder: _vm.placeholder
                  ? _vm.placeholder
                  : _vm.$t.__("common.actions.search"),
                "remote-method": _vm.remoteMethod,
                loading: _vm.loading,
                "loading-text": _vm.$t.__("common.labels.loading"),
                "multiple-limit": _vm.limit,
                size: _vm.size,
                "popper-class": _vm.popperClass
              },
              on: { change: _vm.update, focus: _vm.focusingSearch },
              model: {
                value: _vm.tmpValue,
                callback: function($$v) {
                  _vm.tmpValue = $$v
                },
                expression: "tmpValue"
              }
            },
            [
              _vm._l(_vm.options, function(item, index) {
                return _c("el-option", {
                  key: index,
                  attrs: { label: item.name, value: parseInt(item.id) }
                })
              }),
              _vm._v(" "),
              _vm.enableAddAction
                ? [
                    _vm.hasNoOption
                      ? _c("el-option", {
                          staticClass: "cauto",
                          attrs: {
                            label: _vm.noDataLabel,
                            value: 0,
                            disabled: ""
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "el-option",
                      {
                        staticClass: "p-0 hover-white-bkg white-bkg",
                        class: { "bt-1": _vm.options.length },
                        attrs: { label: "", value: 0 }
                      },
                      [_vm._t("addAction")],
                      2
                    )
                  ]
                : _vm._e()
            ],
            2
          )
        : _c(
            "p",
            [
              _c("person-list", {
                attrs: {
                  list: _vm.selectedItems,
                  size: "small",
                  "related-data": _vm.relatedData
                }
              })
            ],
            1
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }